// Created by carsonaberle at 1/17/22
export const sectionHeaderTitle = 'media upgrades';
export const sectionHeaderSubtitle = 'Enhance your content';
export const mediaEnhancements = 'Media enhancements';
